import { RequestPriority } from '@kfolks/types'
import { z } from 'zod'

/**
 * `formDataLabels` carries the human-readable labels the frontend rendered
 * for `formData` values that came from a `dataSource` or static `options`
 * field. Submit-time snapshot — kept alongside the form data so summaries
 * stay audit-stable when a provider is renamed, a project is closed, etc.
 *
 * Populated by `DynamicFormRenderer` for any select/autocomplete-style
 * field. Plain text inputs / numbers don't need a label and are absent
 * from the map. Backend validates the keys exist in the form schema and
 * stashes the map on `formData.__labels`.
 */
const formDataLabelsSchema = z.record(z.string(), z.string()).optional()

export const requestCreateSchema = z.object({
	requestTypeId: z.uuid(),
	formData: z.record(z.string(), z.unknown()),
	formDataLabels: formDataLabelsSchema,
	priority: z.enum(RequestPriority).optional(),
})

export type RequestCreateInput = z.infer<typeof requestCreateSchema>
